import request from '@/libs/http/index'
// 医疗记录分页
export const medicalRecordsPage = params => {
  return request.get({
    url: `/clinic/medical-records/page`,
    params,
  })
}

// 医疗记录-es分页
export const medicalRecordsEsPage = params => {
  return request.get({
    url: `/clinic/medical-records/es-page`,
    params,
  })
}
// 医疗记录-es列表
export const medicalRecordsEsList = params => {
  return request.get({
    url: `/clinic/medical-records/es-list`,
    params,
  })
}

// 医疗记录详情
export const medicalRecordsDetail = params => {
  return request.get({
    url: `/clinic/medical-records/get`,
    params,
  })
}
// 病历记录详情
export const medicalPrescriptionsDetail = params => {
  return request.get({
    url: `/clinic/medical-records/get-medical-prescriptions`,
    params,
  })
}
// 病历完整详情
export const medicalRecordsFull = params => {
  return request.get({
    url: `/clinic/medical-records/get-full`,
    params,
  })
}
// 历史就诊专用
export const prescriptionsGetList = params => {
  return request.get({
    url: `/clinic/prescriptions/get-list`,
    params,
  })
}

// 单个导出
export const medicalRecordsExport = params => {
  return request.get({
    url: `/clinic/medical-records/get-export`,
    params,
  })
}
// 批量导出
export const medicalRecordsBatchExport = params => {
  return request.get({
    url: `/clinic/medical-records/batch-export`,
    params,
  })
}

// 文书打印接口使用后端统一的医疗打印路由。
export type MedicalPrintParams = {
  id: string | number
}

export const getMedicalRecordPrint = (params: MedicalPrintParams) =>
  request.get({
    url: '/clinic/medical-print/medical-record',
    params,
  })

export const getPrescriptionPrint = (params: MedicalPrintParams) =>
  request.get({
    url: '/clinic/medical-print/prescription',
    params,
  })

export const getTreatmentPrint = (params: MedicalPrintParams & { printExecutionStation?: boolean }) =>
  request.get({
    url: '/clinic/medical-print/treatment',
    params,
  })

export const getDiagnosisCertificatePrint = (params: MedicalPrintParams) =>
  request.get({
    url: '/clinic/medical-print/diagnosis-certificate',
    params,
  })

// 附加打印接口只返回业务数据；配置由 printSetting 中的独立接口获取。
export type ReceiptPrintParams = { id: string | number }
export const getMedicationInstructionPrint = (params: ReceiptPrintParams & { paidOnly?: boolean }) =>
  request.get({ url: '/clinic/medical-print/medication-instruction', params })
export const getMedicationLabelPrint = (params: ReceiptPrintParams) =>
  request.get({ url: '/clinic/medical-print/medication-label', params })
export const getRefundReceiptPrint = (params: ReceiptPrintParams) =>
  request.get({ url: '/clinic/medical-print/refund-receipt', params })
export const getWithdrawalDrugReceiptPrint = (params: ReceiptPrintParams) =>
  request.get({ url: '/clinic/medical-print/withdrawal-drug-receipt', params })
export const getPatientLabelPrint = (params: ReceiptPrintParams & { source?: string }) =>
  request.get({ url: '/clinic/medical-print/patient-label', params })

export const getChargeReceiptPrint = (params: ReceiptPrintParams) =>
  request.get({ url: '/clinic/medical-print/charge-receipt', params })
export const getDispensingReceiptPrint = (params: ReceiptPrintParams) =>
  request.get({ url: '/clinic/medical-print/dispensing-receipt', params })
export const getRegistrationReceiptPrint = (params: { id: string | number; registrationType?: number }) =>
  request.get({ url: '/clinic/medical-print/registration-receipt', params })
